import { State } from 'src/common/types/reducer';

import { DepartmentResume } from '../../departments/dtos';

export const INITIAL_DEPARTMENT_STATE: State<Array<DepartmentResume>> = {
    data: [],
    hasError: false,
    isLoading: true,
};
